import Phaser from 'phaser';
import { FilterTrippyPostFX } from '../game/effects/TrippyPostFX';
import { FilterStarfieldHolesPostFX } from '../game/effects/StarfieldHolesPostFX';

export class BootScene extends Phaser.Scene {
  constructor() { super('Boot'); }

  preload(): void {
    this.load.image('token-machine', '/sprites/token-machine.png');
    this.load.image('token',         '/sprites/token.png');
  }

  async create(): Promise<void> {
    // Register the TrippyPostFX render node so that TrippyPostFX controllers
    // can be added to any camera's FilterList. This is a no-op until a
    // TrippyPostFX Controller is actually attached (Task 15).
    if (this.sys.renderer.type === Phaser.WEBGL) {
      const renderer = this.sys.renderer as Phaser.Renderer.WebGL.WebGLRenderer;
      renderer.renderNodes.addNodeConstructor(
        'FilterTrippyPostFX',
        FilterTrippyPostFX as unknown as new (
          manager: Phaser.Renderer.WebGL.RenderNodes.RenderNodeManager
        ) => Phaser.Renderer.WebGL.RenderNodes.RenderNode
      );
      renderer.renderNodes.addNodeConstructor(
        'FilterStarfieldHolesPostFX',
        FilterStarfieldHolesPostFX as unknown as new (
          manager: Phaser.Renderer.WebGL.RenderNodes.RenderNodeManager
        ) => Phaser.Renderer.WebGL.RenderNodes.RenderNode
      );
    }

    try {
      await document.fonts.load('64px "Bungee Inline"');
      await document.fonts.load('600 15px "Familjen Grotesk"');
      await document.fonts.ready;
    } catch {
      // Non-fatal — fonts may simply fall back.
    }
    this.scene.start('Title');
  }
}
